import * as Yup from 'yup';

export const newPasswordSchema = Yup.object().shape({
    password: Yup.string()
    .required('Password Is Required'),
  passwordConfirmation: Yup.string()
    .oneOf([Yup.ref('password')], 'Passwords Do Not Match')
    .required('Password Confirmation Is Required')
});